"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingDots = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const Css_1 = require("../../Css");
const utils_1 = require("../../utils");
function LoadingDots({ contrast }) {
    const circleCss = Css_1.Css.hPx(8)
        .wPx(8)
        .br4.bgColor(contrast ? Css_1.Palette.Gray500 : Css_1.Palette.Gray300)
        .add("animationName", contrast ? "loadingDotsContrast" : "loadingDots")
        .add("animationDuration", "800ms")
        .add("animationIterationCount", "infinite")
        .add("animationTimingFunction", "linear")
        .add("animationDirection", "alternate").$;
    const tid = (0, utils_1.useTestIds)({});
    return ((0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.py2.df.jcc.$, ...tid.loadingDots, children: (0, jsx_runtime_1.jsx)("div", { "aria-label": "Loading", css: {
                ...circleCss,
                ...Css_1.Css.relative
                    .add("animationDelay", "300ms")
                    .addIn("&:before, &:after", {
                    ...circleCss,
                    ...Css_1.Css.add("content", "' '").absolute.dib.$,
                })
                    .addIn("&:before", Css_1.Css.leftPx(-12).add("animationDelay", "0").$)
                    .addIn("&:after", Css_1.Css.rightPx(-12).add("animationDelay", "600ms").$).$,
            } }) }));
}
exports.LoadingDots = LoadingDots;
